module.exports = __webpack_public_path__ + "img/long-term-cache/male.b61024a54bfc010518e8a89aad0318ee.png";